import React from "react";
import { Container, Row, Col, Carousel, Button } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import "./Careers.css";
import {
  WHY_JOIN,
  CAREER_CAROUSEL,
  CAREER_IMG_CAROUSEL,
} from "../../StaticData/aboutus";
import employee_care_img from "../../assets/images/employee_care_img.jpg";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import DOMPurify from "dompurify";

const Careers = () => {
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      subject: "",
      file: null,
      message: "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string()
        .matches(/^[a-zA-Z\s]+$/, "Invalid name (letters & spaces only)")
        .required("First Name is required"),
      lastName: Yup.string()
        .matches(/^[a-zA-Z\s]+$/, "Invalid name (letters & spaces only)")
        .required("Last Name is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      phone: Yup.string().matches(
        /^[0-9]{10}$/,
        "Phone number must be 10 digits"
      ),
      subject: Yup.string()
        .matches(
          /^[a-zA-Z0-9\s]+$/,
          "Subject can only contain letters, numbers, and spaces"
        )
        .required("Subject is required"),
      message: Yup.string().matches(
        /^[a-zA-Z0-9\s]+$/,
        "Subject can only contain letters, numbers, and spaces"
      ),
      file: Yup.mixed()
        .required("Resume file is required")
        .test("fileType", "Only .pdf and .doc files are allowed", (value) => {
          if (!value) return false;
          return [
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          ].includes(value.type);
        }),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        // const apiUrl = `http://localhost:5000/submit-resume`;
        const apiUrl = `${process.env.REACT_APP_NEWSLETTER_API_URL}/submit-resume`;
        navigate("/thank-you");

        // const apiUrl = `https://570kaq7cm9.execute-api.us-east-1.amazonaws.com/DEV/submit-resume`;

        const ipResponse = await fetch("https://api64.ipify.org?format=json");
        const ipData = await ipResponse.json();
        const userIp = ipData.ip;

        const sanitizedValues = {
          firstName: DOMPurify.sanitize(values.firstName),
          lastName: DOMPurify.sanitize(values.lastName),
          email: DOMPurify.sanitize(values.email),
          phone: DOMPurify.sanitize(values.phone),
          subject: DOMPurify.sanitize(values.subject),
          message: DOMPurify.sanitize(values.message),
        };

        const formData = new FormData();
        // formData.append("to", "inquiry@idexcel.com");
        formData.append("firstName", sanitizedValues.firstName);
        formData.append("lastName", sanitizedValues.lastName);
        formData.append("email", sanitizedValues.email);
        formData.append("phone", sanitizedValues.phone);
        formData.append("subject", sanitizedValues.subject);
        formData.append("resume", values.file);
        formData.append("message", sanitizedValues.message);
        formData.append("ip", userIp);

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            // "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
          body: formData,
        });

        if (response.ok) {
          navigate("/thank-you");
          resetForm();
        } else {
          console.error("Error sending email");
        }
      } catch (error) {
        console.error("Error sending email", error);
      }
    },
  });

  return (
    <div className="careers-page">
      <Helmet>
        <title>Careers | Idexcel</title>
        <meta
          content="current openings usa, current openings india"
          name="keywords"
        />
        <meta
          content="Ready to explore a career with Idexcel? Click here and explore our job openings."
          name="description"
        />
      </Helmet>

      {/* <Container fluid className="careers-banner-container">
        <section className="careers-banner-section"></section>
      </Container> */}

      <motion.div
        className="Productright"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <Container fluid className="careers-banner-container p-0">
          <section className="careers-banner-section"></section>
        </Container>
      </motion.div>

      <Container fluid style={{ background: "#EDF3FF" }}>
        <Container className="px-1 px-lg-4">
          <Row className="m-0 p-0 pt-xxl-3 pt-4 pt-md-5 pt-xl-5 px-xl-4 pb-5 justify-content-center">
            <h2 className="text-center mb-4 section-title">
              Come <span className="textgrad"> Grow </span>Your
              <span className="textgrad"> Career </span> With Us
            </h2>

            <p className="mb-4 text-black">
              We're an Amazon Web Services (AWS) Advanced Tier Services Partner.
              As a recognized leader in cloud professional services, our
              customers choose us because we're the best. That's why we hire the
              best. Which is where you come in.
            </p>
            <p className="mb-4 text-black">
              You're ambitious, looking to create your own niche in a sky's the
              limit working environment. You feel passionate about doing
              exciting and impactful work on the cutting edge of cloud
              technology. You've found the right place.
            </p>
            <a
              href="/careers/recruitment-fraud-awareness"
              //   className="bg-danger fs-6 px-3 py-2 text-white w-auto rounded mx-auto textDecoration"
              className="button careers mb-3"
            >
              Recruitment Fraud Awareness
            </a>
          </Row>
        </Container>
      </Container>

      <Container fluid>
        <Container className="px-0 py-lg-3 px-xl-5">
          <section>
            <Row className="p-0 m-0 px-3 px-md-4 px-xl-4 px-lg-5">
              <h2 className="text-center mb-4 section-title">
                WHAT<span className="textgrad"> WE DO </span>
              </h2>
              <p className="m-0 p-0">
                Idexcel is a leading provider of IT services and solutions to
                clients across the United States and globally. Many of these
                clients are large national and international organizations. We
                focus on four critical business areas when helping clients adopt
                Digital Transformation solutions:
                <a
                  href="/gen-ai-banking"
                  className="text-danger textDecoration"
                >
                  {" "}
                  AI Banking
                </a>
                ,
                <a href="/enterprise-ai" className="text-danger textDecoration">
                  {" "}
                  Enterprise AI
                </a>
                ,
                <a
                  href="/data-analytics"
                  className="text-danger textDecoration"
                >
                  {" "}
                  Data & Analytics
                </a>
                ,
                <a
                  href="/next-gen-modernization"
                  className="text-danger textDecoration"
                >
                  {" "}
                  Next-Gen Modernization
                </a>
                ,
                <a
                  href="/cloud-innovations"
                  className="text-danger textDecoration"
                >
                  {" "}
                  Cloud Innovations
                </a>
                ,
                <a
                  href="/managed-cybersecurity"
                  className="text-danger textDecoration"
                >
                  {" "}
                  Managed Cybersecurity
                </a>
                .
              </p>
            </Row>
          </section>
          <section>
            <Row className="p-0 m-0 px-0 px-lg-4 mt-3 why-join">
              <h2 className="text-center mb-4 section-title">
                Why <span className="textgrad"> Join </span>Idexcel?
              </h2>
              <Row className="m-0 p-0 d-flex justify-content-between px-xl-0 px-md-2">
                {WHY_JOIN?.map((whyJoin, index) => {
                  return (
                    <div
                      key={index}
                      className="box mb-4 position-relative"
                      style={{ background: whyJoin?.bg }}
                    >
                      <h2 className="fs-4 mb-3 fw-semibold text-white">
                        {whyJoin?.title}
                      </h2>
                      <p className="text-white mb-5">{whyJoin?.desc}</p>
                      <div className="careers-box-img">
                        <img src={whyJoin?.img} />
                      </div>
                    </div>
                  );
                })}
              </Row>
            </Row>
          </section>
        </Container>
        {/* </Row> */}
      </Container>

      <Container fluid>
        <Container className="px-0 px-lg-5">
          <section className="p-0 life-at-idexcel">
            <Row className="m-0 p-0 life-at-idexcel-section">
              <h2 className="text-center mb-4 section-title">
                Life at <span className="textgrad"> Idexcel </span>
              </h2>

              <Row className="m-0 p-0 section d-flex flex-md-row flex-lg-row px-xl-4 mb-xl-5">
                <div
                  className="col-lg-6  d-flex align-items-center px-lg-5 paragraph"
                  style={{ background: "#EDF3FF" }}
                >
                  <p className="text-black py-4 py-xl-0 py-lg-0 px-2 px-md-4 mb-0 mb-md-0 fw-normal ">
                    At Idexcel, we provide an environment where our people can
                    pursue their passion and unleash their creative genius
                    through innovation and collaboration. Our culture is strong,
                    vibrant and essential to how we work and serve our
                    customers. We continually advance our culture by creating an
                    environment where people can feed their curiosity and be
                    continuously learning for driving great results and
                    outcomes.
                  </p>
                </div>

                <div className="col-lg-6 h-full p-0 careers-img-1">
                  <Carousel
                    className="carousel"
                    controls={false}
                    autoplay={false}
                  >
                    {CAREER_IMG_CAROUSEL.map((carousel, index) => (
                      <Carousel.Item
                        autoplay={false}
                        key={index}
                        style={{ height: "100%" }}
                      >
                        <div
                          className="img-wrap mb-4"
                          style={{ height: "100%" }}
                        >
                          <img
                            src={carousel.img}
                            alt={carousel.name}
                            className="d-block w-100 h-100"
                            style={{ objectFit: "cover" }}
                          />
                        </div>
                      </Carousel.Item>
                    ))}
                  </Carousel>
                </div>
              </Row>
            </Row>
          </section>
        </Container>
      </Container>

      <Container fluid>
        <Container className="px-lg-0">
          <section className="px-xl-0">
            <Row className="m-0 p-0 justify-content-center">
              <h2 className="text-center mb-4 section-title">
                What Our <span className="textgrad"> Employees Say </span>
              </h2>
              <Row className="m-0 p-0 career-carousel career-carousel-wrap">
                <Carousel fade className="carousel">
                  {CAREER_CAROUSEL?.map((carousel, index) => {
                    return (
                      <Carousel.Item className="p-4" key={index}>
                        <Carousel.Caption>
                          <div className="img-wrap mb-4">
                            <img src={carousel?.img} />
                          </div>
                          <p className="fs-6 desc text-white fw-normal mt-2 mb-4">
                            "{carousel?.desc}"
                          </p>
                          <h2 className="fs-5 text-white fw-semibold">
                            {carousel?.name}
                          </h2>
                          <h4 className="fs-6 text-white fw-semibold">
                            {carousel?.designation}
                          </h4>
                        </Carousel.Caption>
                      </Carousel.Item>
                    );
                  })}
                </Carousel>
              </Row>
            </Row>
          </section>
          <section className="px-xl-0 mt-5">
            <Row className="m-0 p-0 pb-md-5">
              <h2 className="text-center mb-4 section-title">
                Equal Employment <span className="textgrad"> Opportunity </span>
              </h2>
              <p className="p-0">
                Idexcel is an Equal Employment Opportunity employer. This
                meaning, we recruit, hire, compensate, train, promote, transfer,
                and administer all terms and conditions of employment without
                regard to their race, color, religion, national origin, gender
                identity, age, protected veteran status, disability, or other
                protected categories under the applicable law.
              </p>
              <p className="p-0 mt-2 mb-0">
                Idexcel will not tolerate any unlawful discrimination against
                any applicant or employee and any such conduct is expressly
                prohibited.
              </p>
            </Row>
          </section>
        </Container>
      </Container>

      <Row className="m-0 p-0 content pt-0">
        <section className="p-0">
          <Container fluid>
            <Container className="px-0 px-lg-0">
              <Row className="m-0 p-0">
                <Row className="m-0 p-0 we-care-section d-flex flex-md-column pb-md-5 pt-5 pt-xl-0 pb-5 pb-xl-5 flex-lg-row">
                  <div className="col-lg-6 h-full careers-img-2 p-0">
                    <img
                      src={employee_care_img}
                      alt="employee care"
                      className="d-block w-100 h-100"
                      style={{ objectFit: "cover" }}
                    />
                  </div>
                  <div
                    className="col-lg-6  px-4 pb-md-3 pb-5 pb-xl-0 pb-lg-0 d-flex flex-column justify-content-center align-items-center px-lg-5 we-care-our-emp-box"
                    style={{ background: "#EDF3FF" }}
                  >
                    <h2
                      className="mt-3 px-lg-0 mb-3"
                    // style={{ color: "#E46C1C" }}
                    >
                      WE CARE ABOUT{" "}
                      <span style={{ color: "#E46C1C" }}>OUR EMPLOYEES</span>
                    </h2>
                    <a
                      href="/careers/we-care-about-our-employees"
                      className="fs-6 px-3 py-2 w-auto mx-auto textDecoration"
                      style={{ border: "3px solid #E46C1C", color: "#E46C1C" }}
                    >
                      Medical, Dental & Vision Insurance Coverage
                    </a>
                  </div>
                </Row>
              </Row>
            </Container>
          </Container>
        </section>

        <section className="jobs text-center text-white px-2 py-5 px-md-5">
          <h1 className="mb-4 mt-4">Ready to explore a career with Idexcel?</h1>
          <h2 className="fs-4 fw-semibold mb-5">
            Just click on the button below to explore our job openings…
          </h2>
          <div className="d-flex justify-content-center flex-wrap mb-4">
            <a
              href="/careers/current-opening"
              //   className="fs-6 mx-4 px-3 py-2 mb-3 rounded text-white bg-danger textDecoration"
              className="button button-space"
            >
              Current Openings - USA
            </a>
            <a href="/careers/job-listings" className="button button-space">
              Current Openings - India
            </a>
          </div>
        </section>

        <section
          className="mt-xl-0 submit-resume p-0"
          style={{ background: "#EDF3FF" }}
        >
          <h1 className=" fontsize  text-center pt-3 mt-5">
            Submit <span className="textgrad">Resume</span>
          </h1>
          <Container>
            <Row className="m-0 p-0  mt-3">
              <Container className="px-lg-0 pb-5">
                <form
                  className="d-flex  flex-column align-items-center"
                  onSubmit={formik.handleSubmit}
                >
                  <Row className="m-0 p-0 pt-0 px-lg-0">
                    <Col className="col-md-6 col-12 my-2">
                      <input
                        className="w-100 bg-white py-2 px-3 border-0"
                        type="text"
                        placeholder="First Name*"
                        {...formik.getFieldProps("firstName")}
                      />
                      {formik.touched.firstName && formik.errors.firstName && (
                        <div className="text-danger">
                          {formik.errors.firstName}
                        </div>
                      )}
                    </Col>
                    <Col className="col-md-6 col-12 my-2">
                      <input
                        className="w-100 bg-white py-2 px-3 border-0"
                        type="text"
                        placeholder="Last Name*"
                        {...formik.getFieldProps("lastName")}
                      />
                      {formik.touched.lastName && formik.errors.lastName && (
                        <div className="text-danger">
                          {formik.errors.lastName}
                        </div>
                      )}
                    </Col>
                    <Col className="col-md-6 col-12 my-2">
                      <input
                        className="w-100 bg-white py-2 px-3 border-0"
                        type="email"
                        placeholder="Your Email*"
                        {...formik.getFieldProps("email")}
                      />
                      {formik.touched.email && formik.errors.email && (
                        <div className="text-danger">{formik.errors.email}</div>
                      )}
                    </Col>
                    <Col className="col-md-6 col-12 my-2">
                      <input
                        className="w-100 bg-white py-2 px-3 border-0"
                        type="text"
                        placeholder="Phone Number"
                        {...formik.getFieldProps("phone")}
                      />
                      {formik.touched.phone && formik.errors.phone && (
                        <div className="text-danger">{formik.errors.phone}</div>
                      )}
                    </Col>
                    <Col className="col-md-6 col-12 my-2">
                      <input
                        className="w-100 bg-white py-2 px-3 border-0"
                        type="text"
                        placeholder="Subject*"
                        {...formik.getFieldProps("subject")}
                      />
                      {formik.touched.subject && formik.errors.subject && (
                        <div className="text-danger">
                          {formik.errors.subject}
                        </div>
                      )}
                    </Col>
                    {/* <Col className="col-md-6 col-12 my-2">
                    <div className="file-input-wrapper position-relative">
                      <input
                        className="w-100 bg-white px-3 border-0"
                        style={{
                          padding: "5px 0px",
                          position: "absolute",
                          opacity: 0,
                          zIndex: 2,
                          cursor: "pointer",
                        }}
                        type="file"
                        onChange={(event) =>
                          formik.setFieldValue(
                            "file*",
                            event.currentTarget.files[0]
                          )
                        }
                      />
                      <div
                        className="file-placeholder w-100 bg-white px-3 border-0 d-flex align-items-center justify-content-between"
                        style={{
                          padding: "5px 0px",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                        }}
                      >
                        <span className="text-muted">
                          Choose a file* (.pdf, .doc)
                        </span>
                        <span className="btn btn-secondary btn-sm">Choose</span>
                      </div>
                    </div>
                    {formik.touched.file && formik.errors.file && (
                      <div className="text-danger">{formik.errors.file}</div>
                    )}
                  </Col> */}

                    <Col className="col-md-6 col-12 my-2">
                      <div className="file-input-wrapper position-relative">
                        <input
                          className="w-100 bg-white py-2 px-3 border-0"
                          style={{
                            padding: "5px 0px",
                            position: "absolute",
                            opacity: 0,
                            zIndex: 2,
                            cursor: "pointer",
                          }}
                          type="file"
                          onChange={(event) => {
                            const file = event.currentTarget.files[0];
                            if (file) {
                              // Dynamically update the placeholder text with the file name
                              const placeholder =
                                event.currentTarget.nextElementSibling.querySelector(
                                  ".text-muted"
                                );
                              placeholder.textContent = file.name;
                              formik.setFieldValue("file", file);
                            }
                          }}
                        />
                        <div
                          className="file-placeholder w-100 bg-white px-3 border-0 d-flex align-items-center justify-content-between"
                          style={{
                            padding: "5px 0px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                          }}
                        >
                          <span className="text-muted">
                            {formik.values.file
                              ? formik.values.file.name
                              : "Choose a file* (.pdf, .doc)"}
                          </span>
                          <button
                            type="button"
                            className="btn btn-sm bg-black text-white text-align-center"
                            onClick={() => {
                              const fileInput =
                                document.querySelector('input[type="file"]');
                              if (formik.values.file) {
                                // Clear the file
                                formik.setFieldValue("file", null);
                                const placeholder =
                                  document.querySelector(".text-muted");
                                if (placeholder)
                                  placeholder.textContent =
                                    "Choose a file* (.pdf, .doc)";
                                fileInput.value = ""; // Clear the file input value
                              } else {
                                // Trigger file input click
                                fileInput.click();
                              }
                            }}
                          >
                            {formik.values.file ? "Remove" : "Choose"}
                          </button>
                        </div>
                      </div>
                      {formik.touched.file && formik.errors.file && (
                        <div className="text-danger">{formik.errors.file}</div>
                      )}
                    </Col>
                    <Col className="col-md-12 my-2">
                      <textarea
                        className="w-100 bg-white py-2 px-3 border-0"
                        style={{ height: "140px" }}
                        placeholder="Message"
                        {...formik.getFieldProps("message")}
                      />
                      {formik.touched.message && (
                        <div className="text-danger">
                          {formik.errors.message}
                        </div>
                      )}
                    </Col>
                  </Row>
                  <Button type="submit" className="career-submit">
                    Submit
                  </Button>
                </form>
              </Container>
            </Row>
          </Container>
        </section>
      </Row>
    </div>
  );
};

export default Careers;
